module.exports = __webpack_public_path__ + "img/StepByStepApproval.7b206023.svg";